import { render } from "./AddToFavorites.vue?vue&type=template&id=6e4d1c7b&scoped=true"
import script from "./AddToFavorites.vue?vue&type=script&lang=js"
export * from "./AddToFavorites.vue?vue&type=script&lang=js"

import "./AddToFavorites.vue?vue&type=style&index=0&id=6e4d1c7b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e4d1c7b"]])

export default __exports__